import React from "react";

const InputRadio = (props) => {
  const {
    input,
    meta: { touched, error },
  } = props;

  return (
    <>
      <label
        className={`Form-checkbox flex items-center ${
          props.className ? props.className : ""
        } ${props.disabled ? "disabled" : ""}`}
      >
        <input
          {...input}
          id={props.id}
          type="radio"
          disabled={props.disabled}
          className={`checkbox-input opacity-0 w-0 h-0 ${
            touched && error ? "error" : ""
          }`}
        />
        <span
          className={`checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white ${
            props.required ? "is-required" : ""
          }`}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="10" height="10" rx="5" fill="#319D10" />
          </svg>
        </span>
        <span className={`inline-block leading-18.2 ${props.labelClass}`}>
          {typeof props.label === "string" ? (
            <span
              dangerouslySetInnerHTML={{ __html: props.label }}
              className="inline-block"
            ></span>
          ) : (
            props.label
          )}
        </span>
      </label>
    </>
  );
};

InputRadio.defaultProps = {
  disabled: undefined,
};

export default InputRadio;
